var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPipeline = function SvgPipeline(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pipeline_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "#FD9038",
    rx: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M3.076 3.618C3 3.8 3 4.034 3 4.5v5c0 .466 0 .7.076.883a1 1 0 0 0 .541.541c.184.076.417.076.883.076s.699 0 .883-.076a1 1 0 0 0 .54-.541C6 10.199 6 9.966 6 9.5v-5c0-.466 0-.699-.076-.882a1 1 0 0 0-.541-.542C5.199 3 4.966 3 4.5 3s-.699 0-.883.076a1 1 0 0 0-.54.542m5 0C8 3.8 8 4.034 8 4.5v2c0 .466 0 .7.076.883a1 1 0 0 0 .541.541C8.801 8 9.034 8 9.5 8s.699 0 .883-.076a1 1 0 0 0 .54-.541C11 7.199 11 6.966 11 6.5v-2c0-.466 0-.699-.076-.882a1 1 0 0 0-.541-.542C10.199 3 9.966 3 9.5 3s-.699 0-.883.076a1 1 0 0 0-.54.542",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pipeline_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h14v14H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPipeline);
export default ForwardRef;